import { getFormattedDate } from '../utils/utils';
import { getStatus } from '../srtDashboard/utils';

/* eslint-disable camelcase */
class OrderListModel {
  constructor(data) {
    const {
      createdAt,
      contractExpired,
      channel,
      channels,
      businessLegalName,
      typeOfInstallation,
      orderId,
      validatedAt,
      orderAssignedTo,
      name,
      orderComments
    } = data || {};
    const getChannelName = () => {
      if (channels && channels.length) {
        return channels[0].name;
      }
      return (channel && channel.name) || '-';
    };

    this.createdAt = getFormattedDate(createdAt, 'YYYY-MM-DD');
    this.orderStatus = getStatus(data).finalStatus || '-';
    this.contractExpired = contractExpired;
    this.channel = getChannelName();
    this.businessLegalName = businessLegalName;
    this.typeOfInstallation = typeOfInstallation;
    this.orderId = orderId;
    this.completedAt =
      (validatedAt && getFormattedDate(validatedAt, 'YYYY-MM-DD')) || '-';
    this.orderAssignedTo =
      (orderAssignedTo &&
        `${orderAssignedTo.first_name} ${orderAssignedTo.last_name}`) ||
      '-';
    this.name = name;
    this.comments = orderComments;
  }
}

export class OrderHeaderModel {
  constructor(data) {
    const {
      orderId,
      channel,
      businessLegalName,
      typeOfInstallation,
      createdAt,
      orderStatus,
      orderAssignedTo,
      completedAt,
      actions,
      salesRepName,
      lastCaseComment,
      messages
    } = data || {};
    this.orderId = orderId;
    this.channel = channel;
    this.name = salesRepName;
    this.businessLegalName = businessLegalName;
    this.typeOfInstallation = typeOfInstallation;
    this.createdAt = createdAt;
    this.orderStatus = orderStatus;
    this.orderAssignedTo = orderAssignedTo;
    this.completedAt = completedAt;
    this.comments = lastCaseComment;
    this.messages = messages;
    this.actions = actions;
  }
}
export class TypeAheadModel {
  constructor(value) {
    return { label: value, id: value };
  }
}

export class RepModel {
  constructor(data) {
    const { name, id } = data || {};
    return { label: name, id };
  }
}

export class UsersListModel {
  constructor(data) {
    const { id, first_name, last_name, email } = data || {};
    return { label: `${first_name} ${last_name} (${email})`, id };
  }
}

export class ChannelModel {
  constructor(data) {
    const { description, id } = data || {};
    this.text = description;
    this.value = id;
  }
}

export const getOptions = (list, Model) => {
  return list && list.map(element => new Model(element));
};

export default OrderListModel;
